<template>
    <div>
        <!-- Host Buttons -->
        <div class="row no-gutters mb-3 p-1">
            <div class="col-md-3 p-1">
                <button
                    type="button"
                    class="btn btn-primary btn-block"
                    v-b-modal.createInviteModal
                >
                    Invite Guest
                </button>
            </div>

            <div class="col-md-3 p-1">
                <button
                    type="button"
                    class="btn btn-primary btn-block"
                    @click.shift="openRecordingsWindow"
                    @click.exact="openRecordingsModal"
                >
                    View Recordings
                </button>
            </div>

            <div class="col-md-3 p-1">
                <button
                    type="button"
                    class="btn btn-primary btn-block"
                    @click="leaveSession"
                >
                    Homepage
                </button>
            </div>

            <div class="col-md-3 p-1 recordButton">
                <button
                    type="button"
                    class="btn btn-danger btn-block"
                    :disabled="isRecordButtonDisabled"
                    @click="toggleRecord()"
                >
                    {{ isRecording ? "Stop Recording" : "Start Recording" }}
                </button>
            </div>
        </div>

        <create-invite ref="createInviteModal" />

        <RecordingsModal ref="recordingsModal" :sessionId="sessionId" />
        <!-- /Host Buttons -->
    </div>
</template>

<script>
import CreateInvite from "../components/CreateInvite";
import RecordingsModal from "../components/RecordingsModal";

export default {
    name: "HostButtons",
    data() {
        return {
            isRecordButtonDisabled: false,
        };
    },

    computed: {
        isRecording() {
            return this.$store.getters.isRecording;
        },

        sessionId() {
            return this.$store.getters.sessionId;
        }
    },

    watch: {
        isRecording: function () {
            this.isRecordButtonDisabled = false;
        },
    },

    methods: {
        openRecordingsWindow() {
            window.open(`/recordings/${this.sessionId}`);
        },

        openRecordingsModal() {
            this.$bvModal.show('recordingsModal');
        },

        leaveSession() {
            this.$store.dispatch("leaveSession");
        },

        toggleRecord: function () {
            this.isRecordButtonDisabled = true;
            this.$emit("record", !this.isRecording);
        },
    },

    components: {
        CreateInvite,
        RecordingsModal,
    },
};
</script>